// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qhFO","comment":"styles_comment__34SPa"};